import {SafeHtml} from "@angular/platform-browser";
import {Component, ComponentRef, PipeTransform, Type} from "@angular/core";

export {LookupItemComponent} from './lookup-item.component'

export interface LookupEvent {
  kind: LookupKind;
  event: any,
}

export enum LookupKind {
  Bookmark,
  Print,
  ViewDetails
}

export interface Field {
  label: string,
  identifier: string,
  component?: Type<any> | undefined,
  pipe?: PipeTransform
}

export interface IComponent {
  component?: Type<any> | undefined,
  inputs?: Record<string, any>
}

export interface LookupField {
  label: string,
  value: string,
  icon?: SafeHtml,
  component?: Type<any> | undefined
}
